import _ from 'lodash';

export default function CustomListItemColumns(data) {
  return [
    ['list_with_image', 'image'].includes(data.kind) && {
      prop: 'image',
      label: this.$t('customListItem.image'),
      width: 120,
      renderCell: 'storageAttachment'
    },
    data.kind === 'video_list' && {
      prop: 'video',
      label: this.$t('customListItem.video'),
      renderCell: 'storageAttachment'
    },
    data.kind === 'video_list' && {
      prop: 'video_cover',
      label: this.$t('customListItem.videoCover'),
      renderCell: 'storageAttachment'
    },
    ['merchant_list', 'list_with_image', 'image'].includes(data.kind) && {
      prop: 'target',
      label: this.$t('customListItem.target'),
      renderCell: (h, { props: { value } }) => {
        if (value) {
          if (value.cn === 'Merchant') {
            return <div>
              <bean-link KeepNode to={{ name: 'merchants.show', params: { id: value.id } }}>{ value.name }</bean-link>
              {
                !['approved', 'actived'].includes(_.get(value, 'agent.status')) || _.get(value, 'agent.locked_at') ?
                  <div style="word-break: normal;"> ({this.$t('hint.merchantNotActived')})</div> : ''
              }
            </div>;
          } else if (value.cn === 'TicketEvent') {
            return <bean-link KeepNode to={{ name: 'ticket_events.show', params: { id: value.id } }}>{ value.title }</bean-link>;
          } else if (value.cn === 'Link::External') {
            return <span>{ value.url }</span>;
          }
        }
      }
    },
  ].filter(Boolean)
}
